var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4166 8.77167V9.5C17.4156 11.2072 16.8628 12.8683 15.8406 14.2356C14.8185 15.6029 13.3817 16.6032 11.7446 17.0873C10.1075 17.5713 8.35775 17.5132 6.75637 16.9215C5.155 16.3299 3.78777 15.2365 2.8586 13.8043C1.92942 12.3722 1.48809 10.678 1.60041 8.97458C1.71274 7.27111 2.37271 5.64959 3.48189 4.35185C4.59107 3.05411 6.09004 2.14968 7.75524 1.77345C9.42043 1.39722 11.1626 1.56935 12.722 2.26417",
    className: "svgStroke",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4167 3.16667L9.5 11.0913L7.125 8.71625",
    className: "svgStroke",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.7bd99bd4beabcf94c0c691daafda7812.svg";
export { ForwardRef as ReactComponent };